import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_vertical-vector",
  "use": "svg_vertical-vector-usage",
  "viewBox": "0 0 2 8",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 2 8\" id=\"svg_vertical-vector\"><path d=\"M1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM1 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM1 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol